import { Directive,HostBinding,Input,OnInit,ElementRef,Renderer2,OnChanges,SimpleChanges,Inject } from '@angular/core';
import {AbsDomHelperService} from '../abs-utilities/abs-dom-helper.service';

@Directive({
	selector: '[abs-message-wrapper]'
})
export class AbsMessageWrapperDirective implements OnInit,OnChanges {
	firstElement:any;
	launchingElement:any;
	@Input() delay:number;
	@Input('focus-container') focusContainer:any;
	@Input('abs-message-wrapper') absMessageWrapper:any;

	constructor(
		@Inject(ElementRef) private elementRef:ElementRef,
		@Inject(Renderer2) private renderer:Renderer2,
		@Inject(AbsDomHelperService) private domHelper:AbsDomHelperService,
	) { }
	ngOnInit() {
	 	this.delay = this.delay | 10;
	 	// If left as empty string Angular seems to drop the variable declaration later in code
	 	// Don't penalize when someone sets to true or false
	 	if (this.focusContainer || this.focusContainer === '') {
	 		this.focusContainer = true;
	 	} else {
	 		this.focusContainer = false;
	 	}
	 	if (this.absMessageWrapper || this.absMessageWrapper === '') {
	 		this.absMessageWrapper = true;
	 	} else {
	 		this.absMessageWrapper = false;
	 	}
	 }
	ngOnChanges(changes:SimpleChanges) {
		const absMessageWrapper = changes.absMessageWrapper;
		if (!absMessageWrapper.firstChange && absMessageWrapper.currentValue !== absMessageWrapper.previousValue ) {
			if (!this.launchingElement) {
				this.launchingElement = document.activeElement;
			}
			setTimeout(()=>{
				if (absMessageWrapper.currentValue) { 
					const el = this.elementRef.nativeElement;
					if (this.focusContainer) { 
						el.children[0].focus();
					} else {
						this.firstElement = this.domHelper.firstTabableElement(el);
						if (this.firstElement) {
							this.firstElement.focus();
						}
					}
				} else {
					if (this.launchingElement && this.launchingElement.nodeName !== 'BODY') {
						if (this.launchingElement === document.activeElement) {
							return;
						}
						if (this.domHelper.isInDOM(this.launchingElement) && this.domHelper.isTabable(this.launchingElement)) { 
							const prevLaunchingElement = this.launchingElement;
							this.launchingElement.focus();
							if (document.activeElement !== this.launchingElement || document.activeElement.nodeName === 'BODY') {
								this.launchingElement = this.domHelper.previousElement(prevLaunchingElement,true);
								this.launchingElement.focus();
							}
						} else {
							this.launchingElement = this.domHelper.previousElement(this.launchingElement,true);
							this.launchingElement.focus();
						}
					}
				}
			},this.delay);
		}
	}	 
}
